import { useEffect, useState } from 'react';
import axios from 'axios';
import urlToHttp from '../utils/urlToHttp';
const useFetchData = (url: string | undefined | null) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  const [data, setData] = useState<any>();
  useEffect(() => {
    const fetchData = async (_url: string) => {
      try {
        setLoading(true);
        const response = await axios.get(_url);
        const resData = await response.data;
        setData(resData);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    if (url) {
      fetchData(urlToHttp(url)[0]);
    }
  }, [url]);
  return { loading, error, data };
};

export default useFetchData;
